<template>
  <p :class="['txt-discription', classes]"><slot></slot></p>
</template>

<script>
export default {
  name: "MainText",
  props: {
    classes: {
      type: [String, Array, Object],
      default: ""
    }
  }
};
</script>

<style>
.txt-discription {
  font-size: 1rem;
  text-align: right;
  color: #555;
}
</style>
